import { Card, CardBody, Col, Container, Row } from 'react-bootstrap';
import { Outlet } from 'react-router-dom'
import { ToastProvider } from '../context/ToastContext';
import { AuthProvider } from '../context/AuthContext';
 
const LoginLayout = () => {
    return (
        <div className="auth-main">
            <div className="auth-wrapper v1 justify-content-center">
                <div className="auth-form">
                    <Card className="my-5">
                        <Card.Body>
                            <Outlet/>
                        </Card.Body>
                    </Card>
                </div>
            </div>

        </div>
    );
};

export default LoginLayout;
